import { render, staticRenderFns } from "./Open.vue?vue&type=template&id=72bc86be&scoped=true&"
import script from "./Open.vue?vue&type=script&lang=js&"
export * from "./Open.vue?vue&type=script&lang=js&"
import style0 from "./Open.vue?vue&type=style&index=0&id=72bc86be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bc86be",
  null
  
)

export default component.exports